import useReactHookForm from "hooks/useReactHookForm";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useMutation } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import { projectsInitialValues, projectsProperties, projectsValidationSchema } from "./helper";
import { CREATE_PROJECTS } from "utils/graphql/services/live-classes/mutations";
import liveClassClientService from "utils/graphql/liveclassClient";


export const CreateProjects = () => {

  const dispatch = useAppDispatch();
  const history = useHistory();

  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    projectsInitialValues,
    projectsValidationSchema,
    ""
  );

  const [CreateProjects, { loading }] = useMutation(
    CREATE_PROJECTS,
    {
      client: liveClassClientService,
    }
  )

  const handleCreateProjects = async () => {
    try {
      const response = await CreateProjects({
        variables: {
          input: {
            name: watch("name"),
          },
        },
      });

      const createdProject = response?.data?.createProject;

      if (createdProject?.id) {
        dispatch(
          snackbarRequest({
            message: "Project created successfully",
            type: "success",
          })
        );

        history.replace("/live-classes/projects");
      } else {
        dispatch(
          snackbarRequest({
            message: "Failed to create project",
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(
        snackbarRequest({
          message: `${err?.message}` || "Something went wrong",
          type: "error",
        })
      );
    }
  };
  return (
    <div>
      <TypographyHeading>Create Projects</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={projectsProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              sx={{
                width: "200px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateProjects}
              loading={loading}
              disabled={!watch("name")?.trim().length}
            >
              Create Projects
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
